import React from "react"
import { ThemeProvider } from "styled-components"

import useVideoTracking from "hooks/useVideoTracking"
import componentThemeExtension from "utils/componentThemeExtension"

import Video from "components/video"

const ContentfulVideo = ({
  component,
  nested,
  elRef,
  isGrid,
  fullHeight,
  isVideoCard,
  onTimeCallBack,
  ...props
}) => {
  const {
    fillContainer,
    videoId,
    videoObject,
    backgroundColor,
    size,
    position,
    loopVideo,
    muteAudio,
    hideVideoControls,
    autoplayInView,
    thumbnail,
    navigationAnchor,
    trackingId,
    title,
    description,
    videoSignature,
    playerSignature,
    destinationUrl,
    id,
    hideOnPageLoad,
  } = component
  if (!videoObject && !videoId && !videoSignature) {
    return null
  }

  const { trackVideoProgress } = useVideoTracking()
  const progressTracker = trackVideoProgress(trackingId)

  return (
    <ThemeProvider theme={componentThemeExtension(nested ? null : backgroundColor, nested)}>
      <Video
        fillContainer={fillContainer}
        isVideoCard={isVideoCard}
        fullHeight={fullHeight}
        destinationUrl={destinationUrl}
        isGrid={isGrid}
        hideOnPageLoad={hideOnPageLoad}
        dataId={id}
        title={title}
        description={description}
        id={navigationAnchor && navigationAnchor.anchorId}
        elRef={elRef}
        cloudinaryUrl={videoObject && videoObject[0]?.secure_url}
        videoId={videoId}
        videoSignature={videoSignature}
        playerId={playerSignature}
        thumbnail={thumbnail && thumbnail[0]?.secure_url}
        fullWidth={position === "Full-Width" || nested}
        size={size}
        loop={isGrid || loopVideo}
        mute={isGrid || muteAudio}
        noControls={isGrid || hideVideoControls}
        autoPlay={isGrid || autoplayInView}
        onPercentViewed={progressTracker}
        onTimeCallBack={(event) => onTimeCallBack && onTimeCallBack(event)}
        {...props}
      />
    </ThemeProvider>
  )
}

export default ContentfulVideo
